export const getIrritantsContainerWidth = () =>
  typeof window !== 'undefined' &&
  document.getElementById('irritants') &&
  document.getElementById('irritants').offsetWidth;
